import { putRecords } from '../persistence/v2Database';
import { evidenceStore } from './evidenceStore';
import { findingStore } from './findingStore';
import { inspectionStore, prepareAreaRemoval } from './inspectionStore';

// Deleting an area is allowed ONLY for an area that carries no inspection data at all — the
// mis-added fourth bedroom the inspector wants gone. The moment an area holds any item
// disposition, note, reason, photo, finding or area note, deletion is refused (task book §6:
// never silently delete; disabling is the field answer). No data migration exists in this
// round on purpose.
export interface AreaDataSummary {
  settledItems: number;
  annotatedItems: number;
  photos: number;
  findings: number;
  hasAreaNote: boolean;
  hasData: boolean;
}

export function areaDataSummary(areaId: string): AreaDataSummary {
  const state = inspectionStore.get();
  const area = state.areas.find((a) => a.id === areaId);
  const items = state.items.filter((i) => i.areaId === areaId);
  const settledItems = items.filter((i) => i.status !== 'notChecked').length;
  const annotatedItems = items.filter((i) => i.inspectorNote.trim().length > 0 || i.statusReason.trim().length > 0 || i.evidenceIds.length > 0).length;
  const photos = evidenceStore.get().evidence.filter((e) => e.areaId === areaId).length;
  const findings = findingStore.get().findings.filter((f) => f.areaId === areaId).length;
  const hasAreaNote = (area?.note ?? '').trim().length > 0;
  const hasData = settledItems > 0 || annotatedItems > 0 || photos > 0 || findings > 0 || hasAreaNote || area?.completedAt != null;
  return { settledItems, annotatedItems, photos, findings, hasAreaNote, hasData };
}

export function describeAreaData(summary: AreaDataSummary): string {
  const parts: string[] = [];
  if (summary.settledItems > 0) parts.push(`${summary.settledItems} 项已处理`);
  if (summary.annotatedItems > 0) parts.push(`${summary.annotatedItems} 项有备注 / 关联`);
  if (summary.photos > 0) parts.push(`${summary.photos} 张照片`);
  if (summary.findings > 0) parts.push(`${summary.findings} 个问题`);
  if (summary.hasAreaNote) parts.push('有区域备注');
  return parts.length > 0 ? parts.join(' · ') : '没有检查记录';
}

export async function deleteAreaAction(areaId: string, now: number = Date.now()): Promise<{ ok: true } | { ok: false; reason: string }> {
  const area = inspectionStore.get().areas.find((a) => a.id === areaId);
  if (!area) return { ok: false, reason: '找不到这个区域。' };
  const summary = areaDataSummary(areaId);
  if (summary.hasData) return { ok: false, reason: `「${area.name}」已有检查记录（${describeAreaData(summary)}），不能删除；房子没有的区域请停用。` };
  const removal = prepareAreaRemoval(areaId, now);
  if (!removal) return { ok: false, reason: '找不到这个区域。' };
  await putRecords(removal.writes, removal.deletes);
  removal.apply();
  return { ok: true };
}
